import * as React from 'react';
import { EmployeeMatchReportState } from '../../../interface/EmployeeReportInterface';
import * as Helpers from '../../Common/Helpers';

export class EmployeeMatchReportTable extends React.Component<EmployeeMatchReportState, {}> {
    render() {
        if (this.props.EmployeeMatchRate !== undefined) {
            var tran_name_match_rate = ((Math.min(this.props.EmployeeMatchRate.emp_name_count, this.props.EmployeeMatchRate.emp_transaction_count) / Math.max(this.props.EmployeeMatchRate.emp_name_count, this.props.EmployeeMatchRate.emp_transaction_count)) * 100).toFixed(2);
            return <table className="table employee_match_rate">
                <thead><tr><th>Action</th><th>Range of Data Maches</th><th>Steps to Improve the Data</th></tr></thead>
                <tbody>
                    <tr><td>
                        <p>University uploads data to IRIS</p>
                        <p>Upload includes employee transactional file and employee name file</p>
                    </td>
                        <td>
                            <p>The data for this report is based on submissions as of <span className="red">{this.props.EmployeeMatchRate.submission_date}</span></p>
                            <p># of unique employees found in the Employee Transactional file: <span className="red">{Helpers.numberWithCommas(this.props.EmployeeMatchRate.emp_transaction_count)}</span></p>
                            <p># of unique employees found in the Employee Name file: <span className="red">{Helpers.numberWithCommas(this.props.EmployeeMatchRate.emp_name_count)}</span></p>
                        </td>
                        <td>
                            <p>University: Make sure that every employee ID in the transactional file has a matching record in the name file.</p>
                            <p>IRIS: Provide feedback on employee ID match rates between the transactional file and	the	name file. Provide feedback on row counts of data and unique employee IDs that are included	in the data.</p>
                            <p>Census: N/A</p>
                        </td>
                    </tr>
                    <tr><td><p>IRIS reformats the data	to meet	Census specifications</p></td>
                        <td>
                            <p># of unique employee IDs in the transaction file: <span className="red">{Helpers.numberWithCommas(this.props.EmployeeMatchRate.emp_transaction_count)}</span></p>
                            <p># of unique employee IDs in the name file:  <span className="red">{Helpers.numberWithCommas(this.props.EmployeeMatchRate.emp_name_count)}</span></p>
                            <p>% match rate between the two files: <span className="red">{tran_name_match_rate}%</span></p>
                        </td>
                        <td>
                            <p>University: N/A</p>
                            <p>IRIS: Make sure that the number of unique IDs in each file remains consistent and match ratio remains consistent with the original uploaded data.</p>
                            <p>Census: N/A</p>
                        </td>
                    </tr>
                    <tr><td><p>Data transfers from IRIS to Census</p></td>
                        <td>
                            <p>No data transformations take place in this step</p>
                            <p>No comparisons or matches are made</p>
                        </td>
                        <td>
                            <p>University: N/A</p>
                            <p>IRIS: N/A</p>
                            <p>Census: N/A</p>
                        </td>
                    </tr>
                    <tr><td><p>Employee PIK Matching at Census</p></td>
                        <td>
                            <p># of matching employees to census data for PIK: <span className="red">{Helpers.numberWithCommas(this.props.EmployeeMatchRate.employees_rcv_pik)}</span></p>
                            <p>PIK(Protected Identification Key) used by Census to match records across different datasets.</p>
                            <p className="red">Match rate: {this.props.EmployeeMatchRate && this.props.EmployeeMatchRate.pik_pct+'%'}</p>
                        </td>
                        <td>
                            <p>University: Provide	year of	birth and month of birth in the original data uploads to IRIS to ensure	the	highest possible match rate.</p>
                            <p>IRIS: Provide a	reminder to universities that missing names, YOB, or MOB will significantly impact the	match rate at this step.</p>
                            <p>Census: Provide	a quality assurance report of match	rates between the university/IRIS supplied data and	the data available at Census.</p>
                        </td>
                    </tr>
                    <tr><td><p>Positive hits in the Business Registry are then matched to the LBD (Longitudinal Business Database)</p></td>
                        <td>
                            <p className="red">Match rate: % of employees who left the university: {this.props.EmployeeMatchRate && this.props.EmployeeMatchRate.leave_pct}%</p>
                            <p className="red">% of those leavers for whom there are wage data: {this.props.EmployeeMatchRate && this.props.EmployeeMatchRate.wage_pct}%</p>
                        </td>
                        <td>
                            <p>University: Provide as many years of data as possible to improve "leaver" tracking and provide better match opportunities for Census.</p>
                            <p>IRIS: N/A</p>
                            <p>Census: Explore	additional sources of data to improve wage data matching.</p>
                        </td>
                    </tr>
                    <tr><td><p>Place identified "leavers" in categories to allow for reporting.</p></td>
                        <td>
                            <p>Minimum	numbers	of employees must make it to this step in order	for	categories to pass disclosure. Each	category that does not contain enough employees	to prevent reidentification will be suppressed	in final disclosure.</p>
                        </td>
                        <td>
                            <p>University: Provide as	many years of data as possible to improve "leaver" tracking and	provide	better match opportunities for Census.</p>
                            <p>IRIS: Work with Census to develop disclosure proofed match reports.</p>
                            <p>Census: Work with IRIS to develop disclosure proofed match	reports.</p>
                        </td>
                    </tr>
                    <tr><td><p>Disclosure Review</p></td>
                        <td>
                            <p>Final disclosure of aggregate data by Census.</p>
                        </td>
                        <td>
                            <p>University: N/A</p>
                            <p>IRIS: N/A</p>
                        </td>
                    </tr>
                    <tr><td><p>Populate Hot Report</p></td>
                        <td>
                            <p>Census sends aggregated	data to	IRIS for inclusion in Hot Report. As a result of this matching process, your final report is based on data from	<span className="red">{Helpers.numberWithCommas(this.props.EmployeeMatchRate.leavers_w2earnings)}</span> employees.</p>
                        </td>
                        <td>
                            <p>University: N/A</p>
                            <p>IRIS: N/A</p>
                            <p>Census: N/A</p>
                        </td>
                    </tr>
                </tbody>
            </table>
        }
        return <div>Loading...</div>
    }
}